import { CreativeTypeValue } from '../utils/consts';
import { buildFilter, buildMetricParams } from '../utils/reportQueryUtils';
import { getCohortFieldAndPeriod } from './metricsUtils';
import { ASYNC_FILTER_TO_FIELD_CONFIG } from './dimensionsUtils';
import { getMultiValuedFieldsByGroup } from './creativesFormattingUtils';
import { Dimensions } from './consts';
import { IN_OPERATOR } from '../utils/reportsConsts';

const buildBasicFilter = (dimension, values, operator = IN_OPERATOR) =>
    buildFilter(dimension, values, operator, { no_lowercase: true });

const getDefaultFilters = (app, source) => [
    buildBasicFilter(Dimensions.APP, [app]),
    buildBasicFilter(Dimensions.SOURCE, [source]),
    buildBasicFilter(Dimensions.HAS_CREATIVE_PREVIEW, ['True']),
    buildBasicFilter(Dimensions.CREATIVE_TYPE, [
        CreativeTypeValue.image,
        CreativeTypeValue.video,
        CreativeTypeValue.playable,
        CreativeTypeValue.carousel,
    ]),
];

const buildAdditionalFilter = ({ filterName, values }) => {
    const originalField = ASYNC_FILTER_TO_FIELD_CONFIG[filterName]?.originalField;
    if (!originalField) return null;
    return buildBasicFilter(originalField, values);
};

export const getCreativesDefaultParams = (dateRange, app, source, metrics, cohortFields, additionalFilters) => {
    const conversionEvents = [];
    const normalizedCohortFields = cohortFields
        .map(field => {
            const [apiName, period] = getCohortFieldAndPeriod(field.value);
            if (!period) {
                conversionEvents.push(apiName);
                return null;
            }
            return { apiName, apiType: 'cohort', period };
        })
        .filter(Boolean);

    const { cohort_metrics: cohortMetrics, cohort_periods: cohortPeriods } = buildMetricParams(normalizedCohortFields);

    const additionalFormattedFilters = (additionalFilters || []).map(buildAdditionalFilter).filter(Boolean);
    const filters = getDefaultFilters(app, source).concat(additionalFormattedFilters);

    return {
        api_version: 1,
        dimensions: [Dimensions.CREATIVE_IMAGE_HASH],
        cohort_metrics: cohortMetrics,
        cohort_periods: cohortPeriods,
        start_date: dateRange.startDate,
        end_date: dateRange.endDate,
        metrics: metrics.map(({ value }) => value).concat(conversionEvents),
        show_creative_type: true,
        filters,
        is_creative_reporting_query: true,
        is_creative_gallery: true,
        displayNonGraphical: false,
        time_breakdown: ['all'],
        fuzzy: false,
        is_default: false,
        flags: [],
        display_alignment: false,
    };
};

export const getMainCreativesQueryParams = (dateRange, app, source, metrics, cohortFields, additionalFilters) => {
    const requestParams = getCreativesDefaultParams(dateRange, app, source, metrics, cohortFields, additionalFilters);
    const { dimensions } = requestParams;

    return {
        ...requestParams,
        dimensions: dimensions.concat([Dimensions.CREATIVE_EMBEDDING_URL]),
        technical_specs_dimensions: [
            Dimensions.CREATIVE_WIDTH,
            Dimensions.CREATIVE_HEIGHT,
            Dimensions.CREATIVE_ORIENTATION,
            Dimensions.CREATIVE_VIDEO_DURATION_RANGE,
        ],
        creative_measurement_dimensions: [Dimensions.CREATIVE_TYPE],
    };
};

export const getMultiValuedDimensionsQueryParams = (
    dateRange,
    app,
    source,
    metrics,
    cohortFields,
    additionalFilters,
    activeLazyDimensions = []
) => {
    const requestParams = getCreativesDefaultParams(dateRange, app, source, metrics, cohortFields, additionalFilters);
    const { dimensions = [], ...otherMultiValuedDimensions } = getMultiValuedFieldsByGroup(activeLazyDimensions);

    return {
        ...requestParams,
        dimensions: requestParams.dimensions.concat(dimensions),
        ...otherMultiValuedDimensions,
    };
};
